import { Reveal, Eyebrow } from "./Reveal";

const AERIAL_IMG =
  "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsb25kb24lMjBjaXR5JTIwYWVyaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MTkxNjk5MHww&ixlib=rb-4.1.0&q=85";

const MARKETS = [
  { name: "London", note: "Prime commercial, trophy hospitality & mixed-use" },
  { name: "UK Regions", note: "Institutional living & regional portfolios" },
  { name: "Dublin", note: "Offices, hotels & living sectors" },
  { name: "Paris", note: "Trophy assets & luxury hospitality" },
  { name: "Frankfurt & DACH", note: "Prime offices & mixed-use investments" },
  { name: "Iberia & Italy", note: "Hospitality & residential platforms" },
];

export const GeographicReach = () => (
  <section data-testid="geographic-reach-section" className="relative py-28 lg:py-44">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="relative aspect-[4/5] max-h-[640px] w-full overflow-hidden border border-[#E3E0D8]">
              <img
                src={AERIAL_IMG}
                alt="Aerial view of the City of London skyline and the Thames"
                loading="lazy"
                className="w-full h-full object-cover grayscale contrast-110 brightness-[0.95]"
              />
              <span className="absolute top-4 left-4 w-6 h-6 border-t border-l border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute top-4 right-4 w-6 h-6 border-t border-r border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute bottom-4 left-4 w-6 h-6 border-b border-l border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#F6F4F0]/80" aria-hidden="true" />
            </div>
            <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-[#1F1E1B] px-6 py-5">
              <p className="font-sans text-[10px] uppercase tracking-[0.28em] text-[#A8A49B]">Coverage</p>
              <p className="mt-1 font-serif text-lg text-[#F6F4F0]">UK & Europe</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal delay={0.1}>
            <Eyebrow>Geographic Reach</Eyebrow>
            <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
              UK & European <span className="italic">Markets.</span>
            </h2>
            <p className="mt-7 max-w-xl text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              Concentrated focus on established UK and European markets, where detailed submarket knowledge
              and long-standing relationships inform every mandate.
            </p>
          </Reveal>

          <div className="mt-12 border-t border-[#E3E0D8]">
            {MARKETS.map((m, i) => (
              <Reveal key={m.name} delay={0.12 + i * 0.05}>
                <div
                  data-testid={`market-row-${i}`}
                  className="group flex items-baseline gap-6 py-5 border-b border-[#E3E0D8] transition-colors duration-500 hover:bg-[#FFFFFF]"
                >
                  <span className="font-sans text-[11px] tracking-[0.24em] text-[#6E6A61] group-hover:text-[#1F1E1B] transition-colors duration-500">
                    0{i + 1}
                  </span>
                  <span className="font-serif text-xl sm:text-2xl font-light text-[#1F1E1B] min-w-[10rem]">
                    {m.name}
                  </span>
                  <span className="hidden sm:block text-sm font-light text-[#6E6A61]">{m.note}</span>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.4}>
            <p className="mt-8 text-xs font-light leading-relaxed text-[#6E6A61]/80">
              Market coverage reflects the firm's advisory reach and transaction focus, not physical office
              locations.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
